import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./auth/login/login.component";
import {OuvrageComponent} from "./ouvrage/ouvrage.component";
import {AppMainComponent} from "./prime-ng/components/app.main.component";
import {AuthGuard} from "./services/auth.guard";
import {RessourcesNumeriquesListComponent} from "./ressources_numeriques/ressources-numeriques-list/ressources-numeriques-list.component";
import {MiniliensComponent} from "./miniliens/miniliens.component";
import {OgrnPlayListComponent} from "./ogrn_play/ogrn-play-list/ogrn-play-list.component";
import {UsersListComponent} from "./users/users-list/users-list.component";

const routes: Routes = [
  // {
  //   path: 'auth', loadChildren: () => import('./auth/auth.module')
  //     .then(m => m.AuthModule)
  // }
  // {path: '', redirectTo: 'home', pathMatch: 'full'},
  // {
  //   path: 'login', component: LoginComponent
  // },
  // {
  //   path: 'ouvrages', component: OuvrageComponent
  // }

  {
    path: '', component: AppMainComponent, canActivate: [AuthGuard],
    children: [
      {path: 'ouvrage', loadChildren: () => import('./ouvrage/ouvrage.module').then(m => m.OuvrageModule)},
      {path: 'ressources_numeriques/:ouvrageId', loadChildren: () => import('./ressources_numeriques/ressources-numeriques.module').then(m => m.RessourcesNumeriquesModule)},
      {path: 'ressources_numeriques_liste', component: RessourcesNumeriquesListComponent},
      {path: 'miniliens', component: MiniliensComponent, canActivate: [AuthGuard]},
      // {path: 'ogrn_play', component: OgrnPlayListComponent},
      // {path: 'users', component: UsersListComponent},
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
